// Language codes in BCP 47 format — used by i18next and Intl (date/amount formatting).
export const Language = {
	EN: 'en-GB',
	DE: 'de-DE',
	ES: 'es-ES',
	FR: 'fr-FR',
	HR: 'hr-HR',
	IT: 'it-IT',
	LV: 'lv-LV',
	NL: 'nl-NL',
	PL: 'pl-PL',
	PT: 'pt-PT',
	TR: 'tr-TR',
};
